import { MdComputer } from "react-icons/md";
import cv from "../../assets/Ephraim-Udazi-Resume.pdf";

export default function About() {
  return (
    <div className="about">
      <div>
        <div>
          <h1 className="contactH text-center whitespace-nowrap">
            <span className="otherH">&lt;</span>
            <span className="getH" data-clip="About Me">
              About Me
            </span>
            <span className="otherH"> /&gt;</span>
          </h1>
          <div className="my-2 md:my-5 grid justify-center gap-10 md:grid-flow-col md:grid-cols-2 lg:gap-[10%]">
            <div className="pt-2">
              <p className="lead text-black/70 dark:text-white/70">
                <span className="text-black/70 dark:text-white/70 display-6">
                  &#123;{" "}
                </span>
                I’m{" "}
                <span className="text-black/70 dark:text-white/70">&#91;</span>
                <span className="text-primary-10">Ephraim Udazi</span>
                <span className="text-black/70 dark:text-white/70">&#93;</span>,
                an enthusiastic Web and Mobile Fullstack Developer, specializing
                in frontend development. <br />I am a passionate developer
                dedicated to building dynamic, easy to use, friendly websites
                and mobile applications. I am experienced with all stages of the
                development cycle for software projects. I love to combine my
                passion for building with my software development skills to
                continue building exciting application for users of all shades
                and sorts.
                <span className="text-black/70 dark:text-white/70 display-6">
                  {" "}
                  &#125;
                </span>
              </p>
              <a
                href={cv}
                download="Udazi Ephraim CV"
                className="hidden md:block"
              >
                <div className="btn-hover">
                  <button className="my-4 btnC">
                    <span className="span1"></span>
                    <span className="span2"></span>
                    My Resume
                  </button>
                </div>
              </a>
            </div>
            <div className="text-black/70 dark:text-white/70">
              <h1 className="text-primary-10 display-5 mb-4">
                <span className="text-black/70 dark:text-white/70">&lt;</span>
                Summary
                <span className="text-black/70 dark:text-white/70"> /&gt;</span>
              </h1>
              <ul className="flex flex-col gap-3.5">
                <li className="flex gap-3">
                  <span className="text-black/70 dark:text-white/70 whitespace-nowrap">
                    ( ) = &gt;
                  </span>
                  <span className="">
                    Web development with latest technologies: React/NextJs,
                    VueJs/NuxtJs, Nodejs, Angular, TailwindCSS, TypeScript,
                    GraphQL...
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-black/70 dark:text-white/70 whitespace-nowrap">
                    ( ) = &gt;
                  </span>
                  <span className="">
                    Mobile development with React Native, Flutter...
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-black/70 dark:text-white/70 whitespace-nowrap">
                    ( ) = &gt;
                  </span>
                  <span>
                    Minimal designs with creative animations using GSAP, Framer,
                    Three.js...
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-black/70 dark:text-white/70 whitespace-nowrap">
                    ( ) = &gt;
                  </span>
                  <span>Test Driven Development and debugging (Jest).</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-black/70 dark:text-white/70 whitespace-nowrap">
                    ( ) = &gt;
                  </span>
                  <span>
                    Experience with graphic design applications, Adobe, Figma...
                  </span>
                </li>
                <li className="flex gap-3">
                  <span className="text-black/70 dark:text-white/70 whitespace-nowrap">
                    ( ) = &gt;
                  </span>
                  <span>Excellent communication and interpersonal skills.</span>
                </li>
              </ul>
            </div>
          </div>
          <a href={cv} download="Udazi Ephraim CV" className="block md:hidden">
            <div className="btn-hover">
              <button className="my-4 btnC">
                <span className="span1"></span>
                <span className="span2"></span>
                My Resume
              </button>
            </div>
          </a>
        </div>
        <div className="mt-5">
          <h1 className="text-primary-10 display-5 mb-4">
            <span className="text-black/70 dark:text-white/70">&lt;</span>My
            Experience
            <span className="text-black/70 dark:text-white/70"> /&gt;</span>
          </h1>
          <div className="grid justify-between md:grid-cols-2 gap-5 text-black/70 dark:text-white/70">
            <div className="grid grid-flow-col gap-3">
              <MdComputer className="text-primary-10 text-[30px]" />
              <div>
                <p className="uppercase mb-1 text-sm">June 2023 - Present</p>
                <h5 className="uppercase text-black dark:!text-white mb-1">
                  Inheaden - Frontend Engineer
                </h5>
                <p>
                  Collaborating with product team members to implement new
                  feature developments, using my skills in Web and Mobile
                  development.
                </p>
              </div>
            </div>
            <div className="grid grid-flow-col gap-3">
              <MdComputer className="text-primary-10 text-[30px]" />
              <div>
                <p className="uppercase mb-1 text-sm">Feb 2022 - May 2023</p>
                <h5 className="uppercase text-black dark:!text-white mb-1">
                  Abaru.IO - Frontend Engineer
                </h5>
                <p>
                  Built a platform that helps businesses connect easily to their
                  customers through seamless logistics with React/Nextjs,
                  TailwindCSS, RestAPI....
                </p>
              </div>
            </div>
            <div className="grid grid-flow-col gap-3">
              <MdComputer className="text-primary-10 text-[30px]" />
              <div>
                <p className="uppercase mb-1 text-sm">May 2021 - Jan 2022</p>
                <h5 className="uppercase text-black dark:!text-white mb-1">
                  NextGen Devs - Full-Stack Developer
                </h5>
                <p>
                  As team lead, we implemented new features and developments,
                  using my skills in NextJs, GraphQL...
                </p>
              </div>
            </div>
            <div className="grid grid-flow-col gap-3">
              <MdComputer className="text-primary-10 text-[30px]" />
              <div>
                <p className="uppercase mb-1 text-sm">Aug 2020 - June 2021</p>
                <h5 className="uppercase text-black dark:!text-white mb-1">
                  ALTISSADVANCE TECH PRIVATE LIMITED - Frontend Developer
                </h5>
                <p>
                  Design and develop frontend applications. Convert design
                  documents into a working user interface with no loss of
                  fidelity.
                </p>
              </div>
            </div>
            {/* <div className="grid grid-flow-col gap-3">
              <MdComputer className="text-primary-10 text-[30px]" />
              <div>
                <p className="uppercase mb-1 text-sm">May 2020 - May 2021</p>
                <h5 className="uppercase text-black dark:!text-white mb-1">
                  AltSchool Africa - Frontend Developer
                </h5>
                <p>
                  Worked with cross-functional developers on projects where I
                  used my skills on HTML5, CSS, JavaScript, ReactJS to build and
                  deploy user-friendly websites.
                </p>
              </div>
            </div> */}
            <div className="grid grid-flow-col gap-3">
              <MdComputer className="text-primary-10 text-[30px]" />
              <div>
                <p className="uppercase mb-1 text-sm">Always Present</p>
                <h5 className="uppercase text-black dark:!text-white mb-1">
                  Frontend Engineer - Freelance
                </h5>
                <p>
                  I help bring various clients’ visions into reality through
                  seamless process and on time delivery.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
